import React from 'react';
import styled from 'styled-components';

const AvatarContainer = styled.div`
  width: 28px;
  height: 28px;
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 11px;
  flex-shrink: 0;
  ${props => props.isUser ? `
    background: linear-gradient(135deg, #3b74b8 0%, #275386 55%, #1b3c66 100%);
    color: white;
  ` : props.$agent ? `
    background: #dcf3e6;
    color: #166534;
  ` : `
    background: white;
    border: 1.5px solid #3b74b8;
    color: #275386;
  `}
`;

// Same bolt as the header's Aura mark
const AuraBolt = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M13.5 2 4.5 13.2c-.4.5 0 1.3.6 1.3H11l-1.2 7.1c-.1.7.8 1.1 1.3.5l8.4-11c.4-.5 0-1.3-.6-1.3h-5.6l1.3-7.1c.1-.7-.8-1.1-1.1-.7Z"
      fill="currentColor"
    />
  </svg>
);

// A live agent shows their initials; Aura shows its bolt
export const initials = (name) => (name || '').split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('') || 'A';

const Avatar = ({ isUser, agentName }) => (
  <AvatarContainer isUser={isUser} $agent={Boolean(agentName)}>
    {isUser ? 'U' : agentName ? initials(agentName) : <AuraBolt />}
  </AvatarContainer>
);

export default Avatar;
